/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { type SVGProps } from 'react'

export function IconLayoutCompact(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name='icon-layout-compact'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 79.86 51.14'
      {...props}
    >
      <rect
        x={5.84}
        y={5.2}
        width={4}
        height={40}
        rx={2}
        ry={2}
        strokeLinecap='round'
        strokeMiterlimit={10}
      />
      <g stroke='#fff' strokeLinecap='round' strokeMiterlimit={10}>
        <path
          fill='none'
          opacity={0.66}
          strokeWidth='2px'
          d='M7.26 11.56L8.37 11.56'
        />
        <path
          fill='none'
          opacity={0.51}
          strokeWidth='2px'
          d='M7.26 14.49L8.37 14.49'
        />
        <path
          fill='none'
          opacity={0.52}
          strokeWidth='2px'
          d='M7.26 17.39L8.37 17.39'
        />
        <circle cx={7.81} cy={7.25} r={1.16} fill='#fff' opacity={0.8} />
      </g>
      <path
        fill='none'
        opacity={0.75}
        strokeLinecap='round'
        strokeMiterlimit={10}
        strokeWidth='3px'
        d='M15.81 14.49L22.89 14.49'
      />
      <rect
        x={14.93}
        y={18.39}
        width={22.19}
        height={2.73}
        rx={0.64}
        ry={0.64}
        opacity={0.5}
        strokeLinecap='round'
        strokeMiterlimit={10}
      />
      <rect
        x={14.93}
        y={5.89}
        width={59.16}
        height={2.73}
        rx={0.64}
        ry={0.64}
        opacity={0.9}
        strokeLinecap='round'
        strokeMiterlimit={10}
      />
      <rect
        x={14.93}
        y={24.22}
        width={32.68}
        height={19.95}
        rx={2.11}
        ry={2.11}
        opacity={0.4}
        strokeLinecap='round'
        strokeMiterlimit={10}
      />
      <g strokeLinecap='round' strokeMiterlimit={10}>
        <rect
          x={59.05}
          y={38.15}
          width={2.01}
          height={3.42}
          rx={0.33}
          ry={0.33}
          opacity={0.32}
        />
        <rect
          x={54.78}
          y={34.99}
          width={2.01}
          height={6.58}
          rx={0.33}
          ry={0.33}
          opacity={0.44}
        />
        <rect
          x={63.17}
          y={32.86}
          width={2.01}
          height={8.7}
          rx={0.33}
          ry={0.33}
          opacity={0.53}
        />
        <rect
          x={67.54}
          y={29.17}
          width={2.01}
          height={12.4}
          rx={0.33}
          ry={0.33}
          opacity={0.66}
        />
      </g>
      <g opacity={0.5}>
        <circle cx={62.16} cy={18.63} r={7.5} />
        <path d='M62.16 11.63c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-1c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z' />
      </g>
      <g opacity={0.74}>
        <path d='M63.04 18.13l3.38-5.67c.93.64 1.7 1.48 2.26 2.47.56.98.89 2.08.96 3.21h-6.6z' />
        <path d='M66.57 13.19a6.977 6.977 0 012.52 4.44h-5.17l2.65-4.44m-.31-1.43l-4.1 6.87h8c0-1.39-.36-2.75-1.04-3.95a8.007 8.007 0 00-2.86-2.92z' />
      </g>
    </svg>
  )
}
